import { checkRights, haveRouteAccess as haveRouteAccessUtils } from 'components/common/RightsUtils';
import type { RightsMatrix } from 'constants/RightsConstants';
import { useSelector } from 'hooks/useSelector';
import { getUserAccessMatrix } from 'modules/users/selectors/currentUser';
import type { RootState } from 'reducers/index';

type UseRightsOptions = {
  selector?: (state: RootState) => RightsMatrix;
};

/** Answers access questions against a rights matrix — the current user's, unless a selector says otherwise. */
const useRights = ({ selector = getUserAccessMatrix }: UseRightsOptions = {}) => {
  const rightsMatrix = useSelector(selector);

  const hasAccess = (entity: Parameters<typeof checkRights>[0]) => checkRights(entity, rightsMatrix);

  const haveRouteAccess = (pathname: string) => haveRouteAccessUtils(pathname, rightsMatrix);

  return {
    hasAccess,
    haveRouteAccess,
    rightsMatrix,
  };
};

export default useRights;
